import { usePage } from '@inertiajs/react';
import { useSnackbar } from 'notistack';
import React from 'react';

export default function FlashSnackbars() {
  const { enqueueSnackbar } = useSnackbar();
  const { flash } = usePage().props;

  React.useEffect(() => {
    if (flash.message) {
      enqueueSnackbar(flash.message);
    }
  }, [flash.message, enqueueSnackbar]);

  React.useEffect(() => {
    if (flash.error) {
      enqueueSnackbar(flash.error, { variant: 'error' });
    }
  }, [flash.error, enqueueSnackbar]);

  return <></>;
}
